/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Button, Input } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { GetInfoOrder } from 'redux/taoDon/action';
import { get, size, trim } from 'lodash';
import { generatePath, useNavigate } from 'react-router-dom';
import { toastError } from 'components/Toast';
import routesMap from 'layouts/routesMap';

// eslint-disable-next-line max-lines-per-function
const HeaderSearch = (): JSX.Element => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState<string>('');

  const handleChangeTextboxValue = (event: React.FormEvent<HTMLInputElement>): void => {
    setSearchValue(trim(event.currentTarget.value));
  };

  const handleOrderSearch = (): void => {
    if (size(searchValue)) {
      const payload = {
        code: trim(searchValue)
      }
      dispatch(GetInfoOrder(payload, {
        // onBegin: () => {

        // },
        // onFinish: () => {

        // },
        onSuccess: (data: InfoOrderITF) => {
          if(size(data) > 0) {
            handleGotoDetail()
          } else {
            toastError('Không tìm thấy thông tin đơn hàng.');
          }
        },
        onFail: (error: any) => {
          toastError(get(error, 'messages', 'Đã xảy ra lỗi.'));
        }
      }))
    }
  };

  const handleGotoDetail = (): void => {
    // props.toggle();
    navigate(generatePath(routesMap.TRA_CUU_DON_HANG, { maVanDon: trim(searchValue) }));
  };


  const handleEnterSearch = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.charCode === 13) handleOrderSearch();
  };

  return (
    <>
      <div className="sipHeaderSearch">
        <Input
          type="text"
          placeholder={t('Tra cứu đơn hàng')}
          value={searchValue}
          onChange={handleChangeTextboxValue}
          onKeyPress={handleEnterSearch}
        />
        <Button style={{minWidth: 0}} color="primary" onClick={handleOrderSearch}>
          <i className="fa fa-search fa-lg" />
        </Button>
      </div>
    </>
  );
};
export default HeaderSearch;
